export enum EntityType {
  CompanyForProfit = 1742,
  IrrevocableTrust = 1242,
  RevocableTrust = 1241,
  ContactBeneficiary = 1846,
  CharitableOrganization = 1862,
  ContactForGrantor = 1851,
  ContactForTrustee = 1845,
  ContactForTrustProtector = 1819,
  Bank = 305,
  PersonalContact = 25,
  Staff = 1987,
  OrganizationalContact = 2000,
  IrrevocableFuture = 1864
}

export enum TemplateType {
  kinnectUser = 'kinnectUser',
  company = 'company',
  irrevocable = 'irrevocable',
  irrevocableFuture = 'revocable',
  revocable = 'revocable',
  contact = 'contact',
  charitable = 'charitableEntity',
  staff = 'staff',
  organizationalContact = 'organizationalContact',
}

export enum USStates {
  AL = 'Alabama',
  AK = 'Alaska',
  AZ = 'Arizona',
  AR = 'Arkansas',
  CA = 'California',
  CO = 'Colorado',
  CT = 'Connecticut',
  DE = 'Delaware',
  FL = 'Florida',
  GA = 'Georgia',
  HI = 'Hawaii',
  ID = 'Idaho',
  IL = 'Illinois',
  IN = 'Indiana',
  IA = 'Iowa',
  KS = 'Kansas',
  KY = 'Kentucky',
  LA = 'Louisiana',
  ME = 'Maine',
  MD = 'Maryland',
  MA = 'Massachusetts',
  MI = 'Michigan',
  MN = 'Minnesota',
  MS = 'Mississippi',
  MO = 'Missouri',
  MT = 'Montana',
  NE = 'Nebraska',
  NV = 'Nevada',
  NH = 'New Hampshire',
  NJ = 'New Jersey',
  NM = 'New Mexico',
  NY = 'New York',
  NC = 'North Carolina',
  ND = 'North Dakota',
  OH = 'Ohio',
  OK = 'Oklahoma',
  OR = 'Oregon',
  PA = 'Pennsylvania',
  RI = 'Rhode Island',
  SC = 'South Carolina',
  SD = 'South Dakota',
  TN = 'Tennessee',
  TX = 'Texas',
  UT = 'Utah',
  VT = 'Vermont',
  VA = 'Virginia',
  WA = 'Washington',
  WV = 'West Virginia',
  WI = 'Wisconsin',
  WY = 'Wyoming',
}
